import React, { useState, useEffect } from 'react';
import { useFormikContext, getIn } from 'formik';
import { ButtonUI, DialogUI, FormErrorUI, InputUI } from '../../Interface';
import { Box } from '@mui/material';

const NoteDialog = (props) => {
  const [text, setText] = useState('');
  const { open, onClose, noteDialogState } = props;
  const { fieldName } = noteDialogState;
  const { setFieldValue, errors, values, validateField } = useFormikContext();

  useEffect(() => {
    if (open) {
      const currentValue = getIn(values, fieldName);
      setText(currentValue ?? '');
    }
  }, [open, values, fieldName]);

  const handleSave = async () => {
    await setFieldValue(fieldName, text);
    await validateField(fieldName);
    onClose();
  };

  const fieldError = getIn(errors, fieldName);

  return (
    <DialogUI open={open} onClose={onClose} headerContent="Intézkedés" maxWidth="md" fullWidth>
      <Box mt="2rem">
        <InputUI
          value={text}
          type="text"
          variant="standard"
          fullWidth
          helperText={<FormErrorUI message={fieldError} />}
          onChange={(e) => setText(e.target.value ?? '')}
          multiline
          rows={6}
        />
      </Box>

      <Box display="flex" justifyContent="center" gap="0.5rem" mt={2}>
        <ButtonUI text="Mentés" className="bg-success" onClick={handleSave} />
        <ButtonUI text="Mégsem" className="bg-primary" onClick={onClose} />
      </Box>
    </DialogUI>
  );
};

export default NoteDialog;
